import exp from "constants";
import { ApiUtility, IApiResponse } from "../Utilities/ApiUtility.axios";

export enum ReleaseUpdateTypes {
    Unknown = 0,
    Enhancement = 1,
    Development = 2,
    Bugfixes = 3
}

export const ReleaseUpdateTypeOptions = [
    { value: ReleaseUpdateTypes.Enhancement, label: "Enhancement" },
    { value: ReleaseUpdateTypes.Development, label: "Development" },
    { value: ReleaseUpdateTypes.Bugfixes, label: "Bug Fixes" },
];
class UpdatesService {
    route = `/Api/Updates`;

    getUpdatesList = (fromDate: string, toDate: string, start: number, length: any, search: string, sortCol: any, sortDir: any,
        type: ReleaseUpdateTypes[], versions: string[]
    ) => ApiUtility.get(`${this.route}`, { fromDate, toDate, start, length, search, sortDir, sortCol, type, versions });

    addUpdate = (id?: string, params?: any) => ApiUtility.post(`${this.route}/${id}`, params);

    deleteUpdate = (id: string) => ApiUtility.delete(`${this.route}/${id}/Delete`);

    getVersionsList = () => ApiUtility.get<IApiResponse<string[]>>(`${this.route}/versions`);
}
export default new UpdatesService();